// extracted by mini-css-extract-plugin
var _1 = "SelectValueItem-moduleSelectValueItem__Vdp0x";
export { _1 as "SelectValueItem" }
